/**
 * Slugs that have a file at
 * `public/assets/models/thumbnails/{slug}-thumbnail.jpg`.
 * Add a slug here when you add a matching image to that folder.
 */
const CATALOG_MODEL_THUMBNAIL_SLUGS = new Set([
  "cat",
  "chicken",
  "cow",
  "dog",
  "fish",
  "horse",
  "pig",
  "rat",
]);

/**
 * Public URL for a catalog card thumbnail, or `null` if none exists for this slug.
 */
export function getCatalogThumbnailSrc(slug: string): string | null {
  const key = slug.trim().toLowerCase();
  if (!CATALOG_MODEL_THUMBNAIL_SLUGS.has(key)) return null;
  return `/assets/models/thumbnails/${key}-thumbnail.jpg`;
}
